/// <reference path="../custom.d.ts" />
/// <reference path="../objects/classes/basecontroller.ts" />
/// <reference path="../services/composition.service.ts" />
/// <reference path="../services/validation.service.ts" />
/// <reference path="../factories/snackbar.factory.ts" />
/// <reference path="../objects/classes/User.ts"/>
/// <reference path="../objects/classes/licenseplateinformation.ts" />

module App.Controllers {
    import LicensePlate = Classes.LicensePlate

    export interface ICarDetailController extends IBaseController {
        stepName: string
    }

    export class CarDetailController extends BaseController implements ICarDetailController, Interfaces.IStepController {
        static controllerId = 'carDetailController'

        static $inject = [
            '$rootScope',
            '$scope',
            '$q',
            '$stateParams',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId,
            Services.CompositionService.serviceId,
            SnackbarFactory.factoryId,
            'ngDialog',
            '$sce',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId
        ]

        license: string
        licensePlateHolder: string = Constants.licenseTxt
        userLicense: LicensePlate
        carInformation: Classes.ILicensePlateInformation | null
        mileage: number
        mileageString: string
        showFormErrors: boolean = false
        telephone: string
        mileageUnknown: boolean = false
        stepName: string = Constants.routeKeys.cardetail;
        mileageNotRequired: boolean
        leaseOption: string = 'Nee'

        unkownLicense: boolean = false
        licenseNotFound: boolean = false
        customCarBrand: string = ""
        customCarModel: string = ""
        customCarFuel: string = ""

        licenseDesc: string = "Om uw afspraak zo volledig mogelijk in te plannen hebben we uw kenteken nodig."
        mileageDesc: string = " Om uw afspraak in te plannen hebben we uw kilometerstand nodig. Indien u uw kilometerstand niet weet dan kunt u ‘ik weet mijn kilometerstand niet’ aanvinken. Nadat uw afspraak is ingeplant zullen wij u nogmaals om uw kilometerstand vragen."
        myCarUnknownLicense: string = "Als u uw kenteken niet weet dan hebben wij onderstaande informatie nodig om u goed verder te kunnen helpen."
        unknownMileage: string = "Om u zo goed mogelijk te helpen hebben wij mogelijk later alsnog een kilometerstand nodig."


        carBrandOptions: string[]
        fuelTypeOptions: string[]

        customCarBrandHolder: string = Constants.customCarBrandHolder
        customFuelTypeHolder: string = Constants.customFuelTypeHolder

        noStoresAvaible: boolean = false

        constructor($rootScope: Interfaces.IAppRootScope, $scope: ng.IScope, $q: ng.IQService, $stateParams: ng.ui.IStateParamsService, sessionService: App.Interfaces.ISessionService,
            navigationService: App.Interfaces.INavigationService, composition: Interfaces.ICompositionService,
            snackbarFactory: Interfaces.ISnackbarFactory,
            ngDialog: any,
            $sce: any, validationService: Interfaces.IValidationService,
            accountService: Interfaces.IAccountService) {
            super($rootScope, $scope, $q, sessionService, navigationService, composition, ngDialog, $sce, validationService, accountService, snackbarFactory)

            window.pageLoadDatalayerEvent(datalayerPageEvents.stap1)

            this.mileageNotRequired = App.Variables.mileageNotRequired
            this.license = Constants.licenseTxt
            this.telephone = App.Variables.telephone
            this.carBrandOptions = App.Variables.carBrands.map(x => capitalizeFirstLetter(x))
            this.carBrandOptions.unshift(Constants.customCarBrandHolder)

            this.fuelTypeOptions = App.Variables.fuelTypes.map(x => capitalizeFirstLetter(x))
            this.fuelTypeOptions.unshift(Constants.customFuelTypeHolder)

            if (this.sessionService.composition != null) {
                if (this.sessionService.setNumber != this.getSetParam() ||
                    this.sessionService.composition.pipeline != App.Variables.configuratorType) {
                    this.resetSession()
                    this.checkLicenseFromUrl()
                } else {
                    if (this.sessionService.composition.carInformation != null && this.sessionService.composition.carInformation.found) {
                        this.carInformation = this.sessionService.composition.carInformation
                    }

                    if (this.sessionService.composition.customCarBrand != null) {
                        this.customCarBrand = this.sessionService.composition.customCarBrand
                    }

                    if (this.sessionService.composition.customCarModel != null) {
                        this.customCarModel = this.sessionService.composition.customCarModel
                    }

                    if (this.sessionService.composition.customCarFuel != null) {
                        this.customCarFuel = this.sessionService.composition.customCarFuel
                    }

                    if (this.sessionService.composition.mileageUnknown != null || undefined) {
                        this.mileageUnknown = this.sessionService.composition.mileageUnknown
                    }

                    if (this.sessionService.composition.mileage != null && this.sessionService.composition.mileage > 0) {
                        this.mileage = this.sessionService.composition.mileage
                    }
                    else if (parseInt(App.Variables.mileage) > 0) {
                        this.mileage = parseInt(App.Variables.mileage)
                    }

                    if (this.sessionService.composition.mileageUnknown != null) {
                        this.mileageUnknown = this.sessionService.composition.mileageUnknown
                    }

                    if (this.sessionService.composition.licensePlate != '') {
                        this.license = this.sessionService.composition.licensePlate
                    }
                    else {
                        this.checkLicenseFromUrl()
                    }

                    if (this.sessionService.composition.unkownLicense != null) {
                        this.unkownLicense = this.sessionService.composition.unkownLicense
                    }
                }

                this.sessionService.setNumber = this.getSetParam()
            } else {
                this.checkLicenseFromUrl()
                if (App.Variables.mileage != '' && parseInt(App.Variables.mileage) > 0)
                    this.mileage = parseInt(App.Variables.mileage)
            }

            if (this.mileage > 0) {
                this.mileageString = this.mileage.toString()
                this.removeNotNumeric()
            }

            this.checkPageValidation()
        }

        isAuthenticated = () => this.accountService.isAuthenticated;

        checkLicenseFromUrl() {
            if (App.Variables.license != '') {
                this.license = App.Variables.license
                this.licenseChanged()
            }
        }

        licenseChanged = () => {
            var self = this
            var userLicense = this.userLicense
            if (this.license != null) {
                this.license = App.Functions.setLicensePlateDash(this.license.toUpperCase())
                var licenseclean = this.license.replace(new RegExp('-', 'g'), '')
                this.carInformation = null
                this.resetSession()
                this.$rootScope.isPageValid = false
                if (licenseclean.length >= 6) {
                    let composition = this.sessionService.composition
                    if (composition != null && composition.licensePlate != this.license) {
                        composition.licensePlate = this.license
                    }

                    this.setCompositionValue(Constants.apiServiceStateCalls.license, licenseclean, false).then(
                        (result: Classes.IComposition) => {
                            self.userLicense = userLicense
                            self.carInformation = result.carInformation
                            self.customCarBrand = ''
                            self.customCarFuel = ''
                            self.customCarModel = ''
                            self.sessionService.resetMaxStepNumber()

                            if (result.allAllowedStores != null && result.allAllowedStores.length == 0) {
                                this.$scope.value = this.$sce.trustAsHtml(result.noStoresAvailablePopupContent)
                                this.ngDialog.open({
                                    template: 'popupTmpl.html',
                                    scope: this.$scope
                                })
                                this.noStoresAvaible = true
                            }
                            else {
                                this.noStoresAvaible = false
                            }

                            if (this.carInformation == null || this.carInformation.found != true) {
                                this.snackbarFactory.show('Ongeldige kenteken.', 4000)
                                return false
                            }

                            if (this.carInformation.found == true && result.showBrandsPopup && result.alternativeBrands) {

                                var popupContent = result.redirectPopupContent
                                for (var i = 0; i < result.alternativeBrands.length; i++) {
                                    popupContent += `<a href="${result.alternativeBrands[i].brandUrl}">${result.alternativeBrands[i].brandName}</a>`
                                }

                                this.$scope.value = this.$sce.trustAsHtml(popupContent)
                                this.ngDialog.open({
                                    template: 'popupTmpl.html',
                                    scope: this.$scope
                                })
                            }

                            if (App.Variables.allowColorChange &&
                                result.carInformation.newWebColor != null) {
                                App.Variables.websiteColor = '#' + result.carInformation.newWebColor.color

                                try {
                                    this.setCssColors(result.carInformation.newWebColor.color,
                                        result.carInformation.newWebColor.textColor,
                                        result.carInformation.newWebColor.headerLogoUrl,
                                        result.carInformation.newWebColor.headerImageUrl,
                                        result.carInformation.newWebColor.bannerImageUrl)
                                } catch (e) {
                                    debugger
                                }

                            }

                            this.checkPageValidation()

                        }).catch((err) => {
                            self.carInformation = null
                        })
                } else {
                    this.carInformation = null
                }
            } else {
                this.carInformation = null
            }
        }

        selectLicense = (carData: LicensePlate) => {
            this.license = carData.licensePlate
            this.userLicense = carData
            this.licenseNotFound = false
            this.licenseChanged()
        }
        
        resetCardetails = () => {
            if (this.unkownLicense) {
                this.license = null
                this.customCarBrand = this.carBrandOptions[0]
                this.customCarFuel = this.fuelTypeOptions[0]

            } else {
                this.customCarBrand = null
                this.customCarModel = null
                this.customCarFuel = null
            }

            let composition = this.sessionService.composition
            if (composition != null) {
                composition.licensePlate = this.license
                composition.customCarBrand = this.customCarBrand
                composition.customCarModel = this.customCarModel
                composition.customCarFuel = this.customCarFuel
                composition.unkownLicense = this.unkownLicense
                this.sessionService.composition = composition
            }
        }

        licensePlates = (): LicensePlate[] => {
            var licensePlates = this.accountService.user.licensePlates
            licensePlates.forEach(x => {
                if (x.licensePlate) {
                    x.licensePlate = App.Functions.setLicensePlateDash(x.licensePlate)
                }
            })
            return licensePlates
        }

        isValid(isLogicCheck: boolean = false): boolean {
            this.showFormErrors = !isLogicCheck
            var self = this

            let brand = window.getBrand(this.sessionService)

            if (this.distanceIsValid()) {
                if (this.licenseValid()) {
                    if (!self.leaseIsValid()) {
                        return false
                    }

                    //If there are no stores avaiable during winter check
                    if (this.noStoresAvaible) {
                        this.snackbarFactory.show('Geen vestigingen beschikbaar', 4000)
                        return false
                    }
                    var composition = self.sessionService.composition

                    if (this.unkownLicense)
                    {
                        if (composition == null || undefined) {
                            composition = {
                                ...self.sessionService.composition,
                                mileage: 0,
                                unkownLicense: true,
                                customCarBrand: this.customCarBrand,
                                customCarModel: this.customCarModel,
                                customCarFuel: this.customCarFuel,
                                carInformation: null,
                                licensePlate: ''
                            }
                            self.sessionService.composition = composition
                        } else {
                            composition.customCarBrand = this.customCarBrand
                            composition.customCarModel = this.customCarModel
                            composition.customCarFuel = this.customCarFuel
                            composition.unkownLicense = true
                            composition.licensePlate = ''
                            composition.carInformation = null
                        }

                        brand = this.customCarBrand + ' ' + this.customCarModel + ' ' + this.customCarFuel
                    }
                    else
                    {
                        if (composition == null || undefined) {
                            composition = <Classes.IComposition>{}
                        }

                        composition.customCarBrand = ''
                        composition.customCarModel = ''
                        composition.customCarFuel = ''
                        composition.unkownLicense = false

                        if (this.userLicense) {
                            composition.apkWarning = this.userLicense.apkWarning
                            composition.maintenanceWarning = this.userLicense.maintenanceWarning
                            composition.tireWarning = this.userLicense.tireWarning
                        }

                        if (composition.carInformation == null || composition.carInformation == undefined || composition.carInformation.licensePlate == null) {
                            if (!isLogicCheck) {
                                this.snackbarFactory.show('Ongeldige kenteken.', 4000)
                            }

                            return false
                        }
                    }

                    composition.leaseCar = this.leaseOption
                    composition.mileage = (this.mileage != undefined || null ? this.mileage : 0)
                    composition.mileageUnknown = this.mileageUnknown
                    self.sessionService.composition = composition

                    if (!isLogicCheck) {
                        window.sendCarDetailsToDatalayer(brand, this.mileage, this.leaseOption)
                    }

                    return true
                } else {
                    if (!isLogicCheck) {
                        this.snackbarFactory.show('Ongeldige auto gegevens.', 4000)
                    }
                }
            } else {
                if (!isLogicCheck) {
                    this.snackbarFactory.show('Ongeldige kilometerstand.', 4000)
                }
            }

            return false
        }

        distanceIsValid = (): boolean => {
            if (this.mileageUnknown) {
                return true
            }

            if (this.mileage != null && this.mileage > 0) {
                return true
            }

            return false
        }

        leaseIsValid = (): boolean => {
            return this.leaseOption != null && this.leaseOption != ''
        }

        roundCilinders = (cc: number) => {
            return (Math.round(cc / 100)) / 10
        }

        removeNotNumeric = () => {
            if (this.mileage == null)
                this.mileage = 0

            this.mileage = parseInt(this.mileageString.replace(/,/g, '').replace('.', ''))
            this.mileageString = this.mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }

        resetSession() {
            this.sessionService.reset()
        }

        getSetParam(): string {
            return this.getParamValue('set', window.location.href)

        }

        getParamValue(name, url) {
            if (!url) url = location.href
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]")
            var regexS = "[\\?&]" + name + "=([^&#]*)"
            var regex = new RegExp(regexS)
            var results = regex.exec(url)
            return results == null ? null : results[1]
        }

        setCssColors(newColor, textColor, headerLogoUrl, headerImage, bannerImage) {
            var rgbstring = this.hexToRGB('#' + newColor)
            var textRgbString = this.hexToRGB(textColor)

            this.getCssRule('.brandBgcolor').style.backgroundColor = '#' + newColor
            this.getCssRule('.brandBgcolor').style.color = textColor
            this.getCssRule('.product-item.active').style.borderColor = rgbstring
            this.getCssRule('.brandBgcolor-border').style.borderColor = rgbstring
            this.getCssRule('.brandBgcolor-border.active').style.borderColor = rgbstring

            this.getCssRule('.triangle-background').style.background = '#' + newColor
            //this.getCssRule('.triangle-background::after').style.borderBottom = '15px solid #' + newColor;
            this.getCssRule('.popupbgcolor').style.background = '#' + newColor
            //this.getCssRule('.popupbgcolor::after').style.borderBottom = '10px solid #' + newColor;


            this.setImage('headerlogoImage', headerLogoUrl)
            this.setImage('headerImage', headerImage)
            this.setBgImage('bannerImage', bannerImage)

            let existingCustomStyle = $('[name="custom-style"]')
            if (existingCustomStyle.length) {
                existingCustomStyle.remove()
            }

            var style = document.createElement('style')
            style.type = 'text/css'
            style.setAttribute('name', 'custom-style')
            style.innerHTML = '.brand-border { outline: 2px ' + rgbstring + ' solid; }' +
                '.month { color: ' + rgbstring + '}' +
                '.calender-holder mwl-calendar .selected-available { background-color: ' + rgbstring + ' }' +
                '.cookie-optinout-button { background-color: ' + rgbstring + '; color: ' + textRgbString + ' }' +
                '.product-item .action-label { background-color: ' + rgbstring + '; color: ' + textRgbString + ' } '
            document.getElementsByTagName('head')[0].appendChild(style)
        }

        hexToRGB(h) {
            let r = "0", g = "0", b = "0"

            // 3 digits
            if (h.length == 4) {
                r = "0x" + h[1] + h[1]
                g = "0x" + h[2] + h[2]
                b = "0x" + h[3] + h[3]

                // 6 digits
            } else if (h.length == 7) {
                r = "0x" + h[1] + h[2]
                g = "0x" + h[3] + h[4]
                b = "0x" + h[5] + h[6]
            }

            return "rgb(" + +r + "," + +g + "," + +b + ")"
        }

        getCssRule(search) {
            return [].map.call(document.styleSheets, (item) => {
                return [].slice.call(item.cssRules)
            }).reduce((a, b) => {
                return b.concat(a)
            }).filter((rule) => {
                if (rule.selectorText != null)
                    return rule.selectorText.lastIndexOf(search) > -1 && rule.selectorText.lastIndexOf(search) === rule.selectorText.length - search.length
            })[0]
        }

        setImage(id, url) {
            if (url != null && url != '')
                jQuery("#" + id).attr("src", url)
        }

        setBgImage(id, url) {
            if (url != null && url != '')
                jQuery("#" + id).css('background', 'url(' + url + ') no-repeat 0 0').delay(500)
        }

        licenseFocus() {
            if (this.license == Constants.licenseTxt) {
                this.license = ''
            }
        }

        licenseBlur() {
            if (this.license == null || this.license == '') {
                this.license = Constants.licenseTxt
            }
        }

        licenseValid() {
            if (this.unkownLicense) {
                if (this.customCarBrand != '' &&
                    this.customCarBrand != Constants.customCarBrandHolder &&
                    this.customCarModel != '' &&
                    this.customCarModel.length >= 2 &&
                    this.customCarFuel != '' &&
                    this.customCarFuel != Constants.customFuelTypeHolder)
                    return true
            } else {
                return true
            }

            return false
        }

        setLicenseNotFound() {
            if (this.userLicense) {
                this.license = this.licensePlateHolder
                this.userLicense = null
                this.resetCardetails()
            }
        }
    }

    app.controller(CarDetailController.controllerId, CarDetailController)
}